import { ICONS } from "../variables/icons";
import Icon from "./Icon";

const Loader = () => {
  return (
    <div className="loader-component flex items-center justify-center z-50">
      <Icon
        className="cursor-pointer w-[44px] h-[44px] animate-spin text-[#004487]"
        icon={ICONS.SPINNER}
      />
    </div>
  );
};

export default Loader;
